import * as React from 'react';
const NoDeviceIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={185} height={183} fill="none" {...props}>
    <path
      stroke="#424242"
      strokeWidth={2}
      d="M146.787 71.606 94.927 54.75 40.965 71.606m105.822 0-51.86 18.612m51.86-18.612 9.898 16.43a2 2 0 0 1-1.117 2.941l-5.978 1.864m-54.663-2.623L40.965 71.606m53.962 18.612 8.532 13.858a4.002 4.002 0 0 0 4.598 1.722l41.533-12.957m-54.663-2.623-9.234 14.03a4 4 0 0 1-4.47 1.639l-42.71-12.574m56.414-3.095v69.532M40.965 71.606 29.587 87.94a2 2 0 0 0 1.076 3.062l7.85 2.31m56.414 66.438 54.663-17.207V92.841M94.927 159.75l-56.415-17.207v-49.23M91 16.25v20M144.492 30.516l-13.984 14.472M35.103 33.207l16.794 11.088"
    />
  </svg>
);
export default NoDeviceIcon;
